var map = {
	"./alipay.svg": "d4df",
	"./amex.png": "4ee9",
	"./amex.svg": "1a09",
	"./aura.svg": "c6a3",
	"./banescard.png": "b823",
	"./banescard.svg": "1808",
	"./default.svg": "5cd4",
	"./diners.svg": "ca19",
	"./discover.svg": "f32a",
	"./elo-payment-link.svg": "75fe",
	"./elo.svg": "52d7",
	"./hiper.svg": "4538",
	"./hipercard.svg": "3735",
	"./jcb.svg": "e31b",
	"./maestro.svg": "8835",
	"./mastercard.svg": "a7a9",
	"./mir.svg": "47e0",
	"./paypal.svg": "b526",
	"./pix.svg": "d5ce",
	"./sodexo.svg": "9b8c",
	"./unionpay.svg": "9353",
	"./visa.svg": "b8c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55ec";